import { render, staticRenderFns } from "./ContainerStatus.vue?vue&type=template&id=5dc5bb06&scoped=true"
import script from "./ContainerStatus.vue?vue&type=script&lang=js"
export * from "./ContainerStatus.vue?vue&type=script&lang=js"
import style0 from "./ContainerStatus.vue?vue&type=style&index=0&id=5dc5bb06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc5bb06",
  null
  
)

export default component.exports